import React, { PureComponent } from 'react';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import { array, func } from 'prop-types';
import styled, { css } from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import SelectField from '../SolvPatternLibrary/SelectTextField';
import {
  ACTION_CHANGE_VALUE,
  ACTION_LOAD,
  ADD_INSURANCE_DENTIST,
  MARKETPLACE_INSURANCE_DROPDOWN,
} from '../../core/analytics/events';
import { analyticsTrackEvent } from '../../core/analytics';
import { isEmptyObject, safeGet } from '../../core/util/object';
import { emptyFunction } from '../../core/util/function';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';

export const INSURANCE_NAME_ID = 'insurance-name-field';
const Option = styled(MenuItem).withConfig({ componentId: 'sc-1hlnwer-0' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.squid};
  ${({ selected }) =>
    selected &&
    css`
      color: ${colors.crunchBerry};
      background-color: unset !important;
    `};
`;

const SelectArrow = styled.span.withConfig({ componentId: 'sc-1hlnwer-1' })`
  border: 3px solid ${colors.lanaDelGrey};
  border-top: none;
  border-left: none;
  width: 6px;
  height: 6px;
  top: calc(50% - 6px);
  right: 10%;
  transform: rotate(${Math.PI / 4}rad);
  transform-origin: top left;
`;

const Input = styled(SelectField).withConfig({ componentId: 'sc-1hlnwer-2' })`
  width: 328px;
  margin: 0 auto;
  text-align: left;

  & label {
    pointer-events: none;
  }
`;

type OwnProps = {
  form: formShape;
  className?: string;
  initialValue?: any;
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  marketplaceInsurers?: array;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onChange?: func;
  placement: string;
};

type Props = OwnProps & typeof InsuranceCarrierInput.defaultProps;

export default class InsuranceCarrierInput extends PureComponent<Props> {
  static defaultProps = {
    onChange: emptyFunction,
  };

  componentDidMount() {
    const trackingProperties = { action: ACTION_LOAD };
    analyticsTrackEvent(MARKETPLACE_INSURANCE_DROPDOWN, trackingProperties);
  }

  getInputProps() {
    const { form, className } = this.props;
    return {
      ...form.getFieldProps(INSURANCE_NAME_ID, {
        validateTrigger: ['onBlur', 'onChange'],
        initialValue: safeGet(this.props.initialValue)('id'),

        onBlur: () => analyticsTrackEvent(ADD_INSURANCE_DENTIST),
        rules: [],
      }),
      value: form.getFieldValue(INSURANCE_NAME_ID) || '',
      id: INSURANCE_NAME_ID,
      label: 'Choose Dental Insurance',
      error: !!form.getFieldError(INSURANCE_NAME_ID),
      SelectProps: {
        native: false,
        IconComponent: SelectArrow,
        classes: {
          icon: undefined,
        },
      },
      OptionElement: Option,
      selectOptions: this.marketplaceInsurersToSelectOptions(),
      className,
      onChange: this.handleChange,
    };
  }

  handleChange = (event: any) => {
    const optionId = event.target.value;
    this.props.form.setFieldsValue({ [INSURANCE_NAME_ID]: optionId });
    this.props.onChange(optionId);

    const optionSelected = this.marketplaceInsurersToSelectOptions().find(
      (option) => option.value === optionId
    );
    if (!isEmptyObject(optionSelected)) {
      const trackingProperties = {
        action: ACTION_CHANGE_VALUE,
        label: optionSelected.label,
        value: optionSelected.value,
        placement: this.props.placement,
      };
      analyticsTrackEvent(MARKETPLACE_INSURANCE_DROPDOWN, trackingProperties);
    }
  };

  marketplaceInsurersToSelectOptions = () => [
    { key: 'default', value: '', label: 'None' },
    ...this.props.marketplaceInsurers.map((insurer: any) => ({
      key: insurer.id,
      label: insurer.display_name,
      value: insurer.id,
    })),
  ];

  render = () => <Input {...this.getInputProps()} data-testid="insurance-carrier-input" />;
}
